"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableBundlePricingHandles = exports.disableQuantityHandles = void 0;
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var with_state_1 = require("../../misc/with-state");
var emoji_filter_1 = __importDefault(require("../../utils/emoji-filter"));
var unavailable_regions_1 = require("../../utils/unavailable-regions");
var with_loading_ui_1 = __importDefault(require("../../utils/with-loading-ui"));
var default_usage_1 = __importDefault(require("../oos-signup/default-usage"));
var oos_modal_1 = __importDefault(require("../oos-signup/oos-modal"));
var unavailable_in_region_disclaimer_1 = __importDefault(require("../shared-components/unavailable-in-region-disclaimer"));
var giftCardFieldsTag = 'Gift Card PDP Fields';
// in order to determine which products should have quantities disabled, we have to pick a field that exists as a cart item as well
// so we can't use metafields or tags, which makes this hard-coded list of handles the least-worst option
exports.disableQuantityHandles = ['gift-card'];
exports.disableBundlePricingHandles = ['new-mom-diaper-giveaway'];
var submitButtonId = 'add-to-cart-app-button';
var oosButtonId = 'oos-app-button';
var AddToCartApp = /** @class */ (function (_super) {
    __extends(AddToCartApp, _super);
    function AddToCartApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            giftCardRecipientEmail: '',
            giftCardRecipientMessage: '',
            giftCardRecipientName: '',
            selQuantity: 1,
            isModalOpen: false,
        };
        _this.isPreferenceValid = function (productPreference, variant, selectedVariant) {
            var numOptions = _this.props.product.options.length;
            switch (true) {
                case numOptions >= 2:
                    if (productPreference.optionType === 'base') {
                        return variant.option1 === productPreference.optionValue && variant.option2 === selectedVariant.option2;
                    }
                    else if (productPreference.optionType === 'secondary') {
                        return variant.option1 === selectedVariant.option1 && variant.option2 === productPreference.optionValue;
                    }
                case numOptions >= 1:
                    return variant.title === "".concat(productPreference.optionValue);
                default:
                    return false;
            }
        };
        _this.buttonEnabled = function (productPreference, selectedVariant) {
            var variants = _this.props.product.variants;
            return variants.some(function (variant) {
                return _this.isPreferenceValid(productPreference, variant, selectedVariant);
            });
        };
        _this.getDefaultProduct = function (productPreference) {
            var variants = _this.props.product.variants;
            return productPreference.optionType === 'secondary'
                ? variants.find(function (variant) { return variant.option2 === productPreference.optionValue; })
                : variants.find(function (variant) { return variant.option1 === productPreference.optionValue; });
        };
        _this.getOptionValues = function () {
            var e_1, _a;
            var variants = _this.props.product.variants;
            var option1 = new Set();
            var option2 = new Set();
            var option3 = new Set();
            try {
                for (var variants_1 = __values(variants), variants_1_1 = variants_1.next(); !variants_1_1.done; variants_1_1 = variants_1.next()) {
                    var variant = variants_1_1.value;
                    option1.add(variant.option1);
                    option2.add(variant.option2);
                    option3.add(variant.option3);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (variants_1_1 && !variants_1_1.done && (_a = variants_1.return)) _a.call(variants_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return [__spreadArray([], __read(option1), false), __spreadArray([], __read(option2), false), __spreadArray([], __read(option3), false)];
        };
        _this.getPrice = function () { return (_this.props.selectedVariantStore.variant ? _this.props.selectedVariantStore.variant.price * _this.state.selQuantity : 0); };
        _this.handleDecQuantityClick = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { selQuantity: _this.state.selQuantity - 1 })); }); };
        _this.handleIncQuantityClick = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { selQuantity: _this.state.selQuantity + 1 })); }); };
        _this.handleSelectChange = function (productPreference, selectedVariant) {
            var variants = _this.props.product.variants;
            var selVariant = variants.find(function (variant) { return _this.isPreferenceValid(productPreference, variant, selectedVariant); }) || _this.getDefaultProduct(productPreference);
            // the type of tags is wrong
            var tags = _this.props.product.tags;
            var selVariantWithProduct = (function () {
                if (!selVariant)
                    return undefined;
                var priceDollars = (0, currency_js_1.default)(selVariant.price, { fromCents: true }).value;
                return __assign(__assign({}, selVariant), { price: priceDollars, product: { tags: tags, title: _this.props.product.title } });
            })();
            _this.props.selectedVariantStore.change({ newVariant: selVariantWithProduct, emitViewItemEventToGa: true });
        };
        _this.handleGiftCardRecipientEmailChange = function (e) {
            var giftCardRecipientEmail = e.target.value;
            _this.setState(function (state) { return (__assign(__assign({}, state), { giftCardRecipientEmail: giftCardRecipientEmail })); });
        };
        _this.handleGiftCardRecipientMessageChange = function (e) {
            var giftCardRecipientMessage = (0, emoji_filter_1.default)(e.target.value);
            _this.setState(function (state) { return (__assign(__assign({}, state), { giftCardRecipientMessage: giftCardRecipientMessage })); });
        };
        _this.handleGiftCardRecipientNameChange = function (e) {
            var giftCardRecipientName = e.target.value;
            _this.setState(function (state) { return (__assign(__assign({}, state), { giftCardRecipientName: giftCardRecipientName })); });
        };
        _this.onSubmit = function (e) {
            e.preventDefault();
            _this.handleAddToCartClick(document.getElementById(submitButtonId));
        };
        _this.handleAddToCartClick = function (el) { return __awaiter(_this, void 0, void 0, function () {
            var selVariant, propertiesFromState, properties;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                selVariant = this.props.selectedVariantStore.variant;
                if (!selVariant) {
                    return [2 /*return*/];
                }
                propertiesFromState = ['giftCardRecipientEmail', 'giftCardRecipientMessage', 'giftCardRecipientName'].reduce(function (obj, key) {
                    if (_this.state[key]) {
                        obj[key] = _this.state[key];
                    }
                    return obj;
                }, {});
                properties = (0, unavailable_regions_1.addUnavailableRegionsToCartLineProperties)(propertiesFromState, (_a = this.props.selectedVariantStore.variant) === null || _a === void 0 ? void 0 : _a.product.tags);
                (0, with_loading_ui_1.default)(el, function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, window.cartApp.add([[selVariant.id, { properties: properties, quantity: this.state.selQuantity }]])];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }, 'Adding...');
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    AddToCartApp.prototype.render = function () {
        var _this = this;
        var product = this.props.product;
        var variants = product.variants;
        var selVariant = this.props.selectedVariantStore.variant;
        var allowOOSSignups = (window.addToCartApp.settings || {}).allowOOSSignups;
        var optionValues = this.getOptionValues();
        var buttonColorClass = (window.addToCartApp.settings && window.addToCartApp.settings.buttonColorClass) || 'light-wisteria';
        var isAvailableForDiaperBundlesOnly = product.tags.includes('Store - Available For Diaper Bundles Only');
        var handleOpenOOSModal = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { isModalOpen: true })); }); };
        var handleCloseOOSModal = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { isModalOpen: false })); }); };
        if (!selVariant)
            return null;
        // key fixes a bug where adding to the cart would prevent further updates
        return (React.createElement("div", { className: 'add-to-cart', key: selVariant.id },
            React.createElement("form", { onSubmit: this.onSubmit },
                !exports.disableQuantityHandles.includes(product.handle) && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'flex-container align-bottom margin-bottom-7' },
                        React.createElement("div", { className: 'flex-child-shrink' },
                            React.createElement("div", { className: 'add-to-cart-section-text' }, "QTY"),
                            React.createElement("div", { className: 'add-to-cart-quant margin-right-8' },
                                React.createElement("a", { onClick: this.handleDecQuantityClick, className: 'add-to-cart-quant-btn padding-2 h6 margin-right-1' }, "-"),
                                this.state.selQuantity,
                                React.createElement("a", { onClick: this.handleIncQuantityClick, className: 'add-to-cart-quant-btn padding-2 h6 margin-left-1' }, "+")))))),
                product.options.length >= 2 && variants.length > 1 && (React.createElement("div", { className: 'flex-child-grow margin-bottom-7' },
                    React.createElement("div", { className: 'add-to-cart-section-text' }, product.options[1]),
                    React.createElement("fieldset", { className: 'flex-child-grow' }, optionValues[1].map(function (secondaryOption) {
                        var productPreference = { optionType: 'secondary', optionValue: secondaryOption };
                        return (React.createElement("div", { className: 'add-to-cart-toolbar', key: secondaryOption },
                            React.createElement("input", { defaultChecked: selVariant.option2 === secondaryOption, type: 'radio', id: 'radio' + secondaryOption, name: 'radioVariants1', onClick: function () { return _this.handleSelectChange(productPreference, selVariant); } }),
                            React.createElement("label", { defaultChecked: true, className: 'enabled', htmlFor: 'radio' + secondaryOption }, secondaryOption)));
                    })))),
                product.options.length >= 1 && variants.length > 1 && (React.createElement("div", { className: 'flex-child-grow margin-bottom-14' },
                    React.createElement("div", { className: 'add-to-cart-section-text' }, product.options[0]),
                    React.createElement("fieldset", { className: 'flex-child-grow margin-bottom-14' }, optionValues[0].map(function (baseOption) {
                        var productPreference = { optionType: 'base', optionValue: baseOption };
                        return (React.createElement("div", { className: 'add-to-cart-toolbar', key: baseOption },
                            React.createElement("input", { defaultChecked: selVariant.option1 === baseOption, disabled: !_this.buttonEnabled(productPreference, selVariant), type: 'radio', id: 'radio' + baseOption, name: 'radioVariants2', onClick: function () { return _this.handleSelectChange(productPreference, selVariant); } }),
                            React.createElement("label", { className: _this.buttonEnabled(productPreference, selVariant) ? 'enabled' : 'disabled', htmlFor: 'radio' + baseOption }, baseOption)));
                    })))),
                product.tags.includes(giftCardFieldsTag) && (React.createElement("div", { className: 'margin-vertical-10' },
                    React.createElement("div", { className: 'font-bold margin-bottom-4' }, "Recipient Information"),
                    React.createElement("div", { className: 'margin-bottom-3' },
                        React.createElement("input", { type: 'text', onChange: this.handleGiftCardRecipientNameChange, value: this.state.giftCardRecipientName, placeholder: 'Full Name', required: true })),
                    React.createElement("div", { className: 'margin-bottom-3' },
                        React.createElement("input", { type: 'email', pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$', onChange: this.handleGiftCardRecipientEmailChange, value: this.state.giftCardRecipientEmail, placeholder: 'Email Address', required: true })),
                    React.createElement("div", { className: 'margin-bottom-3' },
                        React.createElement("div", { className: 'text-warm-grey' }, "Gift Message"),
                        React.createElement("textarea", { onChange: this.handleGiftCardRecipientMessageChange, value: this.state.giftCardRecipientMessage, style: { minHeight: 100 } })))),
                React.createElement("div", null, (function () {
                    var _a, _b, _c;
                    if (isAvailableForDiaperBundlesOnly) {
                        return (React.createElement("a", { className: 'button text-center width-100 light-wisteria padding-vertical-4', href: '/collections/diaper-bundle' }, "Available for bundles only"));
                    }
                    else if ((_a = _this.props.nonShoppableSettings) === null || _a === void 0 ? void 0 : _a.enabled) {
                        return (React.createElement("a", { className: 'button text-center width-100 light-wisteria padding-vertical-4', href: _this.props.nonShoppableSettings.buttonLink, target: '_blank' }, _this.props.nonShoppableSettings.buttonText));
                    }
                    else if (!selVariant.available && !((_b = _this.props.nonShoppableSettings) === null || _b === void 0 ? void 0 : _b.enabled)) {
                        return (React.createElement("button", { id: oosButtonId, className: 'button text-center width-100 bg-alto padding-vertical-4', onClick: allowOOSSignups ? handleOpenOOSModal : function () { } }, "Out of stock"));
                    }
                    else if (!((_c = _this.props.nonShoppableSettings) === null || _c === void 0 ? void 0 : _c.enabled)) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement(unavailable_in_region_disclaimer_1.default, { productTags: product.tags, iconUrl: window.addToCartApp.exclamationTriangleIconURL, unavailableClassName: 'text-xs font-bold margin-bottom-1' }),
                            React.createElement("button", { className: (0, classnames_1.default)('add-to-cart-button button text-center width-100 padding-vertical-4', buttonColorClass), id: submitButtonId, type: 'submit' },
                                "Add to Cart -",
                                ' ',
                                selVariant.compare_at_price ? (React.createElement("span", { className: 'strike', style: { opacity: 0.8 } },
                                    "$",
                                    (0, currency_js_1.default)(selVariant.compare_at_price, { fromCents: true }).multiply(_this.state.selQuantity).toString())) : null,
                                ' ',
                                "$",
                                (0, currency_js_1.default)(_this.getPrice()).toString())));
                    }
                })())),
            !selVariant.available && allowOOSSignups && React.createElement(default_usage_1.default, { variant: selVariant }),
            React.createElement(oos_modal_1.default, { variant: selVariant, isOpen: this.state.isModalOpen, handleModalClose: function () {
                    _this.setState(handleCloseOOSModal);
                } })));
    };
    return AddToCartApp;
}(React.Component));
var AddToCart = (0, with_state_1.WithSelectedVariantStore)(AddToCartApp);
exports.default = AddToCart;
